import { useGlobalContext } from "../../context/GlobalContext";

export const useModals = () => {
  const { updateData } = useGlobalContext();

  const setOpenVehicleStatus = (): void => {
    updateData("openVehicleStatus", true);
  };

  const setOpenVehicleLedger = (): void => {
    updateData("openVehicleLedger", true);
  };

  const setCloseVehicleLedger = (): void => {
    updateData("openVehicleLedger", false);
  };

  const setOpenLogo = () => {
    updateData("openLogo", true);
  };

  const closeLogo = () => {
    updateData("openLogo", false);
    updateData("selectedLogo", null);
  };

  const setLogo = (logoUrl: string) => {
    updateData("selectedLogo", logoUrl);
    setOpenLogo();
  };

  const setOpenAdvanceBalance = (): void => {
    updateData("openAdvanceBalance", true);
  };

  const openSyncCollection = (staffId?: string | null) => {
    updateData({
      openSyncCollection: true,
      staffId: staffId ?? null,
    });
  };

  const closeSyncCollection = () => {
    updateData({
      openSyncCollection: false,
      staffId: null,
    });
  };

  const openCalculateWage = (staffId?: string | null) => {
    updateData({
      openCalculateWage: true,
      staffId: staffId ?? null,
    });
  };

  const closeCalculateWage = () => {
    updateData({
      openCalculateWage: false,
      staffId: null,
    });
  };

  return {
    setOpenVehicleStatus,
    setOpenVehicleLedger,
    setCloseVehicleLedger,
    setOpenLogo,
    closeLogo,
    setLogo,
    setOpenAdvanceBalance,
    openSyncCollection,
    closeSyncCollection,
    openCalculateWage,
    closeCalculateWage,
  };
};
